
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/predictive-traits",
      function () {
        return require("private-next-pages/customer-studio/predictive-traits.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/predictive-traits"])
      });
    }
  